var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40.759,
  viewBox: "0 0 40.759 29.074"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M35.3.558a199 199 0 0 0-29.832 0 4.91 4.91 0 0 0-3.51 2.313A9.24 9.24 0 0 0 .279 7.179a96.6 96.6 0 0 0 0 14.677 9.24 9.24 0 0 0 1.675 4.307 5.2 5.2 0 0 0 3.51 2.393 214.5 214.5 0 0 0 29.832 0 5.5 5.5 0 0 0 3.51-2.473 9.2 9.2 0 0 0 1.675-4.227 102 102 0 0 0 0-15.075 9 9 0 0 0-1.555-4.227A4.37 4.37 0 0 0 35.3.558M15.275 21.775V7.1l12.762 7.338Z",
  "data-name": "YOUTUBE ICON"
})));
export default SvgYoutube;